module.exports = __webpack_public_path__ + "static/img/yuanjing.f1a3009e.png";